import { VolumeMinusIcon } from './VolumeMinusIcon';

/**
 * author: Austin Andrews
 * id D8BFD10F-6D55-4EE1-8D30-5B5CB064CBBF
 * name volume-minus
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-minus.svg
 * tags
 * - Audio 
 * - Home Automation 
 * - Cellphone / Phone 
 */
export const VolumeDecreaseIcon = VolumeMinusIcon;
export default VolumeDecreaseIcon